import { DerivedCampaignStatus } from "src/graphql";
import type { BadgeProps } from "@hightouch/htui";

export const TRIGGER_CAMPAIGN_API_DOCS_URL = `${
  import.meta.env.VITE_DOCS_URL
}/api-reference#operation/TriggerCampaign`;

export const STATUS_BADGE_VARIANT: Record<string, BadgeProps["variant"]> = {
  // Campaign statuses
  draft: "subtle",
  scheduled: "info",
  running: "success",
  paused: "warning",
  archived: "subtle",
  // Campaign-run statuses (in_progress -> scheduling -> sending -> completed/cancelled/error)
  in_progress: "info",
  scheduling: "info",
  sending: "info",
  completed: "success",
  cancelled: "subtle",
  error: "error",
};

export const canShowCampaignReporting = (
  status: DerivedCampaignStatus | null | undefined,
  hasSends: boolean,
): boolean =>
  hasSends && status != null && status !== DerivedCampaignStatus.Draft;

// An unloaded status counts as live, so a live campaign never flashes state meant only for drafts.
export const isLiveCampaignStatus = (
  status: DerivedCampaignStatus | null | undefined,
): boolean => status !== DerivedCampaignStatus.Draft;

export const hasCampaignEnded = (
  status: DerivedCampaignStatus | null | undefined,
): boolean =>
  status === DerivedCampaignStatus.Completed ||
  status === DerivedCampaignStatus.Archived;
